const MONTHS = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
const WD = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];

export const rub = (n: number | null | undefined) => (n === null || n === undefined ? '—' : `${n.toLocaleString('ru-RU').replace(/ /g, ' ')} ₽`);

export const hh = (h: number) => `${String(h).padStart(2, '0')}:00`;
export const slotText = (from: number | null, to: number | null) => (from === null || to === null ? '' : `${hh(from)}–${hh(to)}`);

export function dayMonth(iso: string | null) {
  if (!iso) return '';
  const [, m, d] = iso.split('-').map(Number);
  return `${d} ${MONTHS[m - 1]}`;
}

export const dm = (month: number, day: number) => `${day} ${MONTHS[month - 1]}`;
/** «14 февраля, каждый год» или «14 февраля 2027» для разового события. */
export const dateRepeat = (d: { month: number; day: number; year: number | null }) => (d.year ? `${dm(d.month, d.day)} ${d.year}` : `${dm(d.month, d.day)}, каждый год`);

export function weekdayShort(iso: string) {
  const d = new Date(iso + 'T12:00:00Z');
  return `${WD[d.getUTCDay()]}, ${d.getUTCDate()}`;
}

/** Сегодняшняя дата по Москве (UTC+3). */
export const mskToday = () => new Date(Date.now() + 3 * 3600_000).toISOString().slice(0, 10);

/** «Сегодня», «завтра» или «12 марта» относительно today. */
export function dayWord(iso: string | null, today: string | null = mskToday()) {
  if (!iso) return '';
  if (today && iso === today) return 'сегодня';
  if (today) {
    const t = new Date(today + 'T12:00:00Z');
    t.setUTCDate(t.getUTCDate() + 1);
    if (t.toISOString().slice(0, 10) === iso) return 'завтра';
  }
  return dayMonth(iso);
}

export const FORM_RU: Record<string, string> = { classic: 'Классический', airy: 'Воздушный', comp: 'В коробке', mono: 'Монобукет' };
export const GAMMA_RU: Record<string, string> = { pastel: 'пастель', warm: 'тёплые', white: 'белые', bright: 'яркие', deep: 'глубокие' };
export const FLOWER_RU: Record<string, string> = {
  rose: 'розы',
  spray_rose: 'кустовые розы',
  eustoma: 'эустома',
  hydrangea: 'гортензия',
  chrysanthemum: 'хризантемы',
  carnation: 'гвоздики',
  eucalyptus: 'эвкалипт',
  orchid: 'орхидеи',
  sunflower: 'подсолнухи',
};

export const OCCASION_RU: Record<string, string> = {
  birthday: 'день рождения',
  love: 'годовщина, романтика',
  sorry: 'хочу извиниться',
  thanks: 'сказать спасибо',
  just: 'просто так',
  anniversary: 'годовщина',
  holiday: 'праздник',
  other: 'важный день',
};

export const RELATION_DATIVE: Record<string, string> = { mom: 'маме', love: 'любимому человеку', friend: 'другу', work: 'коллеге', other: 'близкому человеку' };

/** Склонение: «для мамы». Для имён — как есть. */
export function forWhom(name: string | null, relation: string | null) {
  if (relation === 'mom' && (!name || /^мам/i.test(name))) return 'для мамы';
  return name ? `для: ${name}` : 'в подарок';
}

/** Короткое описание вкуса для подписи: что нравится, а если знаем только «не нравится», то это. Пусто — вкуса не знаем. */
export function tasteSummary(t: { formsLike: string[]; gammasLike: string[]; flowersLike: string[]; formsDislike: string[]; gammasDislike: string[]; flowersDislike: string[] } | null): string {
  if (!t) return '';
  const likes = tasteText(t);
  if (likes) return likes;
  const no = [...t.gammasDislike.map((g) => GAMMA_RU[g]), ...t.formsDislike.map((f) => FORM_RU[f]?.toLowerCase()), ...t.flowersDislike.map((f) => FLOWER_RU[f] ?? f)].filter(Boolean);
  return no.length ? `не нравится ${no.slice(0, 4).join(', ')}` : '';
}

export function tasteText(t: { formsLike: string[]; gammasLike: string[]; flowersLike: string[] } | null) {
  if (!t) return '';
  const parts = [...t.gammasLike.map((g) => GAMMA_RU[g]), ...t.formsLike.map((f) => FORM_RU[f]?.toLowerCase()), ...t.flowersLike.map((f) => FLOWER_RU[f] ?? f)].filter(Boolean);
  return parts.slice(0, 5).join(', ');
}
